import { render, staticRenderFns } from "./OrderListSummary.vue?vue&type=template&id=306d4e00&scoped=true&"
import script from "./OrderListSummary.vue?vue&type=script&lang=js&"
export * from "./OrderListSummary.vue?vue&type=script&lang=js&"
import style0 from "./OrderListSummary.vue?vue&type=style&index=0&id=306d4e00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306d4e00",
  null
  
)

export default component.exports